module.exports = __webpack_public_path__ + "img/Profile-3.e4fde155.png";